import _jsx from "@babel/runtime/helpers/jsx";
import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
export const TabContainerContext = /*#__PURE__*/createContext(null);
export const TabContentContext = /*#__PURE__*/createContext(null);
export const NavbarContext = /*#__PURE__*/createContext(null);
export const useTabContainer = () => useContext(TabContainerContext);
export const useTabContent = () => useContext(TabContentContext);
export const useNavbar = () => useContext(NavbarContext);
export function TabContainerProvider(_ref) {
  let {
    value,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(TabContainerContext.Provider, {
    value: value
  }, void 0, children);
}
export function TabContentProvider(_ref2) {
  let {
    value,
    children
  } = _ref2;
  return /*#__PURE__*/_jsx(TabContentContext.Provider, {
    value: value
  }, void 0, children);
}
export function NavbarProvider(_ref3) {
  let {
    value,
    children
  } = _ref3;
  return /*#__PURE__*/_jsx(NavbarContext.Provider, {
    value: value
  }, void 0, children);
}